import { useTranslation } from 'react-i18next'

import { getItemsFromIdwellApiResponse } from '../../../../../../utils/api'
import { FieldStackedLabel } from '../../../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import { getMockManagerOptions } from '../../../../../RentalPortalListing'
import { toUserSelectItemsFromOption, UserSelect } from '../../../../../User'
import { APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY } from '../../RentalPortalApplicantProfileHeaderInfoItems.constants'
import {
  APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME,
  QA_NAME_APPLICANT_RESPONSIBLE_MANAGER_SELECT,
} from '../ApplicantResponsibleManagerModal.constants'

function ApplicantResponsibleManagerModalFields() {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <FormikField
        Component={FormFieldSelectNG}
        Field={FieldStackedLabel}
        Select={UserSelect}
        controlProps={{
          contentProps: {
            inputProps: {
              placeholder: t(
                'RentalPortal.ListingProfileResponsibleManagerPlaceholderKey'
              ),
            },
          },
        }}
        emptyValue={null}
        fieldComponentProps={{
          label: t(APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY.responsibleManager),
        }}
        getData={getMockManagerOptions}
        getDataItems={getItemsFromIdwellApiResponse}
        getErrorProps={getFormikFormFieldErrorProps}
        listProps={{
          emptyProps: {
            text: t(
              'RentalPortal.ListingProfileResponsibleManagerNoOptionsKey'
            ),
          },
        }}
        name={APPLICANT_RESPONSIBLE_MANAGER_FIELD_NAME}
        qaName={QA_NAME_APPLICANT_RESPONSIBLE_MANAGER_SELECT}
        toPreparedItems={toUserSelectItemsFromOption}
      />
    </FormFieldsContainer>
  )
}

export default ApplicantResponsibleManagerModalFields
